import React, { FC } from 'react';

import Dialog from '@crehana/ui/dist/Dialog';

import { VideoDialogProps } from '../../types';

import LazyTrailerVideo from './LazyVideo';

interface VideoDialogTypes extends VideoDialogProps {
  onDismiss: () => void;
}

const VideoDialog: FC<React.PropsWithChildren<VideoDialogTypes>> = ({
  courseData,
  onDismiss,
}) => (
  <Dialog open={!!courseData} className="overflow-hidden" onDismiss={onDismiss}>
    <LazyTrailerVideo courseData={courseData} />
    <div className="p-24">
      <p className="font-subtitle1 mb-8">{courseData?.title}</p>
      <p className="font-body4">
        {courseData?.professor?.fullName} | {courseData?.professor?.occupation}
      </p>
    </div>
  </Dialog>
);

export default VideoDialog;
